import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { KycServiceService } from '../services/kyc-service/kyc-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.apiUrl;
  userDetails: any;

  constructor(private http: HttpClient,
    private kycProfileService: KycServiceService,
  ) { }

  // login(payload: { email: string; password: string }): Observable<any> {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/login-with-email`,
  //     payload
  //   ).pipe(
  //     tap((res: any) => {
  //       if (res?.status && res?.data?.token) {
  //         localStorage.setItem('access_token', res.data.token);
  //         localStorage.setItem('user_data', JSON.stringify(res.data));

  //         this.kycProfileService.loadProfileAfterLogin();
  //       }
  //     })
  //   );
  // }
  login(payload: { email: string; password: string }): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/customer/login-with-email`,
      payload
    ).pipe(
      tap((res: any) => {

        if (res?.status && res?.data?.token) {

          this.setSession(
            res.data.token,
            res.data
          );

          this.kycProfileService.loadProfileAfterLogin();
        }
      })
    );
  }
  private setSession(token: string, userData: any): void {

    localStorage.setItem(
      'access_token',
      token
    );

    localStorage.setItem(
      'user_data',
      JSON.stringify(userData)
    );
  }
  // getUser() {
  //   const data = localStorage.getItem('user_data');
  //   return data ? JSON.parse(data) : null;
  // }
  getUser(): any {

    const data = localStorage.getItem('user_data');

    if (!data) {
      return null;
    }

    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  getToken(): string | null {

    return localStorage.getItem('access_token');
  }
  hasToken(): boolean {

    return !!this.getToken();
  }
  // getToken(): string | null {
  //   return localStorage.getItem('access_token');
  // }
  isAuthenticated(): boolean {
    return !!this.getToken();
  }
  validateToken(): Observable<any> {

    return this.http.get(
      `${this.baseUrl}/customer/get-wallet`
    );
  }
  clearSession(): void {

    localStorage.removeItem('access_token');
    localStorage.removeItem('user_data');

    sessionStorage.clear();
  }
   logout(): Observable<any> {

    const token = this.getToken();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    });

    return this.http.post(
      `${this.baseUrl}/customer/logout`,
      {},
      { headers }
    ).pipe(
      tap(() => {
        this.clearSession();
      })
    );
  }
   getWalletBalance() {

    return this.http.get(
      `${this.baseUrl}/customer/get-wallet`
    );
  }
   signupPage(body: any) {

    return this.http.post(
      `${this.baseUrl}/customer/register`,
      body
    );
  }
   verifyOtpChangePassword(body: any) {

    return this.http.post(
      `${this.baseUrl}/customer/otp-verify-change-password`,
      body
    );
  }
   forgotPassword(body: any) {

    return this.http.post(
      `${this.baseUrl}/customer/forgot-password`,
      body
    );
  }
   loginWithOTP(body: any) {

    return this.http.post(
      `${this.baseUrl}/customer/login-with-mobile`,
      body
    );
  }
  mobileVerifyOtp(body: any): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/customer/verify-otp`,
      body
    ).pipe(
      tap((res: any) => {

        if (res?.status && res?.data?.token) {

          this.setSession(
            res.data.token,
            res.data
          );

          this.kycProfileService.loadProfileAfterLogin();
        }
      })
    );
  }
}
  // logout() {
  //   const token = this.getToken();
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${token}`,
  //     'Accept': 'application/json'
  //   });

  //   return this.http.post(
  //     `${this.baseUrl}/customer/logout`,
  //     {},
  //     { headers }
  //   ).pipe(
  //     tap(() => {
  //       localStorage.removeItem('access_token');
  //       localStorage.removeItem('user_data');
  //       // localStorage.removeItem('admin_id');
  //     })
  //   );
  // }

  // signupPage(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/register`,
  //     body)

  // }
  // getWalletBalance() {
  //   return this.http.get(
  //     `${this.baseUrl}/customer/get-wallet`)
  // }

  // forgotPassword(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/forgot-password`,
  //     body
  //   );
  // }

  // verifyOtpChangePassword(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/otp-verify-change-password`,
  //     body
  //   );
  // }
  // loginWithOTP(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/login-with-mobile`,
  //     body
  //   );
  // }

  // mobileVerifyOtp(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/verify-otp`,
  //     body
  //   ).pipe(
  //     tap((res: any) => {
  //       if (res?.status && res?.data?.token) {
  //         localStorage.setItem('user_data', JSON.stringify(res.data));
  //         localStorage.setItem('access_token', res.data.token);

  //         this.kycProfileService.loadProfileAfterLogin();
  //       }
  //     })
  //   );
  // }
